export const MODAL_NOTIFICATION_GUARD_KEY = 'issac_modal_shown_notifs';
export const GIFT_NOTIFICATION_GUARD_KEY = 'issac_gift_shown_notifs';

export type NotificationIdentifier = string | number | null | undefined;

export const normalizeNotificationId = (id: NotificationIdentifier): string => {
  if (id === null || id === undefined) {
    return '';
  }

  return String(id).trim();
};

export const getShownNotificationIds = (storageKey: string): Set<string> => {
  try {
    const raw = localStorage.getItem(storageKey);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) {
      return new Set();
    }

    return new Set(parsed.map(normalizeNotificationId).filter(Boolean));
  } catch {
    return new Set();
  }
};

export const markNotificationsShown = (
  ids: NotificationIdentifier[],
  storageKey: string,
  limit = 500,
): Set<string> => {
  const shown = getShownNotificationIds(storageKey);

  ids.forEach((id) => {
    const normalizedId = normalizeNotificationId(id);
    if (normalizedId) {
      shown.add(normalizedId);
    }
  });

  localStorage.setItem(storageKey, JSON.stringify(Array.from(shown).slice(-limit)));
  return shown;
};

export const markNotificationShown = (
  id: NotificationIdentifier,
  storageKey: string,
  limit = 500,
): Set<string> => markNotificationsShown([id], storageKey, limit);

export const wasNotificationShown = (id: NotificationIdentifier, storageKey: string): boolean => {
  const normalizedId = normalizeNotificationId(id);
  return Boolean(normalizedId && getShownNotificationIds(storageKey).has(normalizedId));
};

export const isNotificationFromCurrentSession = (
  createdAt: string | null | undefined,
  sessionStartedAt: number,
  toleranceMs = 5000,
): boolean => {
  if (!createdAt) {
    return true;
  }

  const createdTime = new Date(createdAt).getTime();
  if (!Number.isFinite(createdTime)) {
    return true;
  }

  return createdTime >= sessionStartedAt - toleranceMs;
};
